export default {
  prepareSequenceImages: Array(31)
  .fill('')
  .map((v, i) =>
      require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
  ),
  designSliderImage: require('../../../product drawing/pet stairs.png'),
  designImageList: [
    {
      number: 1,
      side: 'TOP',
      image: require('../../../parts/petstairs/01.png'),
    },
    {
      number: 2,
      side: 'BOTTOM',
      image: require('../../../parts/petstairs/02.png'),
    },
    {
      number: 3,
      side: 'BACK',
      image: require('../../../parts/petstairs/03.png'),
    },
    {
      number: 4,
      side: 'FRONT',
      image: require('../../../parts/petstairs/04.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/petstairs/05.png'),
  assembleSequenceImages: Array(50)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/28_pet_stairs/petstairs${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/Pet Stairs.jpg'),
  completeImagePc: require('../../../complete/Pet Stairs.jpg'),
};
